import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@ui';
import { FormInput } from 'components/Form/next';
import Joi from 'joi';
import React, { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

interface Props {
    name: string;
    label?: React.ReactNode;
}

export const exemptionsRules = Joi.array()
    .max(10)
    .items({
        start: Joi.date().required().label('Startdatum'),
        end: Joi.date()
            .min(Joi.ref('start', { render: true }))
            .label('Enddatum')
    });

export const ExemptionsAssistent = ({ name, label }: Props) => {
    const { control } = useFormContext();
    const { fields, append, remove } = useFieldArray({ control, name });
    const { watch, setValue } = useFormContext();
    const exemptions = watch(name);

    useEffect(() => {
        exemptions?.forEach((exemption, index) => {
            if (exemption.start && !exemption.end) {
                setValue(`${name}.${index}.end`, exemption.start);
            }
        });
    });

    return (
        <div className="tw-mb-6">
            <Button className="tw-mb-8 tw-w-full" type="button" color="success" size="sm" onPress={() => append({})}>
                Ausnahme hinzufügen
            </Button>

            {fields.length > 0 && (
                <>
                    <div className="d-flex justify-content-around">
                        <span>Startdatum</span>
                        <span className="mr-5">Enddatum</span>
                    </div>
                    <hr className="mt-1 mb-3" />
                </>
            )}
            {fields.map((field, index) => (
                <div key={field.id} className="d-flex align-items-start tw-gap-4">
                    <div className="tw-flex-1">
                        <FormInput.DatePicker name={`${name}.${index}.start`} />
                    </div>
                    <div className="tw-flex-1">
                        <FormInput.DatePicker name={`${name}.${index}.end`} />
                    </div>
                    <Button type="button" color="error" css={{ mt: '$2' }} auto onPress={() => remove(index)}>
                        <FontAwesomeIcon icon={faTrash} />
                    </Button>
                </div>
            ))}
        </div>
    );
};
